import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, HashRouter } from 'react-router';
import AuthProvider from './providers/AuthProvider';
import { Toaster } from 'sonner';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import App from './App';
import { DialogProvider } from './providers/DialogProvider';
import { DialogManager } from './components/DialogManager';
import { SocketProvider } from './providers/SocketProvider';
import { platform } from '@/lib/platform';

const Router = platform.isNative ? HashRouter : BrowserRouter;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours (time data remains in cache)
      staleTime: 1000 * 60 * 5, // 5 minutes (time until data is considered stale)
    },
  },
});

// // 2. Create a persister (using localStorage in this example)
// const localStoragePersister = createSyncStoragePersister({
//   storage: window.localStorage,
// });

// persistQueryClient({
//   queryClient,
//   persister: localStoragePersister,
//   maxAge: 1000 * 60 * 60 * 24, // 24 hours (how long to persist data)
//   // You can add more options here, like a buster string for cache invalidation
// });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SocketProvider>
          <Router>
            <DialogProvider>
              <App />
            </DialogProvider>
            <Toaster duration={3000} />
            <DialogManager />
          </Router>
        </SocketProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
